import i18n from '@/helpers/i18n'
import dayjs from 'dayjs'
import {
  INDICATOR_STATUS_TODO,
  INDICATOR_STATUS_IN_PROGRESS,
  INDICATOR_STATUS_DONE,
  INDICATOR_STATUS_NOT_APPLICABLE
} from '@/consts/enums'

export default {
  getStatusBadge(indicator) {
    // Règle d'affaire https://app.clickup.com/t/1d9pf48

    const badges = this.badges()

    if (!this.isApplicable(indicator)) return badges.badgeNotApplicable
    if (indicator.status === INDICATOR_STATUS_DONE) return badges.badgeDone
    if (this.isLate(indicator)) return badges.badgeLate
    if (indicator.status === INDICATOR_STATUS_TODO) return badges.badgeTodo
    if (indicator.status === INDICATOR_STATUS_IN_PROGRESS) return badges.badgeInProgress

    return null
  },

  isLate(indicator) {
    if (!indicator) return false
    return indicator.targetDate && indicator.targetDate < dayjs().format('YYYY-MM-DD')
  },

  isApplicable(indicator) {
    if (!indicator) throw new Error("Parameter 'indicator' must not be null.")
    return indicator.status !== INDICATOR_STATUS_NOT_APPLICABLE
  },

  getGroupedStatusBadges(groupIndicators) {
    if (!groupIndicators.length > 0) return []

    const data = new Map()
    const badges = this.badges()

    data.set(badges.badgeNotApplicable.icon, {
      badge: badges.badgeNotApplicable,
      count: 0
    })
    data.set(badges.badgeLate.icon, { badge: badges.badgeLate, count: 0 })
    data.set(badges.badgeInProgress.icon, { badge: badges.badgeInProgress, count: 0 })
    data.set(badges.badgeInProgress.icon, { badge: badges.badgeInProgress, count: 0 })
    data.set(badges.badgeTodo.icon, { badge: badges.badgeTodo, count: 0 })
    data.set(badges.badgeDone.icon, { badge: badges.badgeDone, count: 0 })

    for (const indicator of groupIndicators) {
      const badge = this.getStatusBadge(indicator)
      const entry = data.get(badge.icon)
      entry.count++
    }

    return Array.from(data.values()).filter(x => x.count > 0)
  },

  getGroupedStatusBadgesProgress(stats) {
    if (!stats) return []

    const badges = this.badges()
    const data = new Map()
    if (stats.todoCount || stats.inProgressCount)
      data.set(badges.badgeTasks.icon, { badge: badges.badgeTasks, count: stats.todoCount || 0 + stats.inProgressCount || 0 })
    if (stats.doneCount !== undefined) data.set(badges.badgeDone.icon, { badge: badges.badgeDone, count: stats.doneCount })
    if (stats.inProgressCount !== undefined)
      data.set(badges.badgeInProgress.icon, { badge: badges.badgeInProgress, count: stats.inProgressCount })
    if (stats.lateCount !== undefined) data.set(badges.badgeLate.icon, { badge: badges.badgeLate, count: stats.lateCount })
    if (stats.todoCount !== undefined) data.set(badges.badgeTodo.icon, { badge: badges.badgeTodo, count: stats.todoCount })
    if (stats.notApplicableCount !== undefined)
      data.set(badges.badgeNotApplicable.icon, { badge: badges.badgeNotApplicable, count: stats.notApplicableCount })
    if (stats.documentsTodoCount !== undefined)
      data.set(badges.badgeDocumentsTodo.icon, { badge: badges.badgeDocumentsTodo, count: stats.documentsTodoCount })

    return Array.from(data.values())
  },

  badges() {
    return {
      badgeTasks: {
        icon: 'check-circle',
        iconPack: 'fas',
        color: 'primary',
        backgroundColor: 'pale-blue',
        label: i18n.t('indicator-status-badge-TASKS')
      },
      badgeNotApplicable: {
        icon: 'ban',
        iconPack: 'fas',
        color: 'grey',
        backgroundColor: 'grey-lightest',
        label: i18n.t('indicator-status-badge-NOT_APPLICABLE')
      },
      badgeLate: {
        icon: 'clock',
        iconPack: 'far',
        color: 'danger',
        backgroundColor: 'pale-red',
        label: i18n.t('indicator-status-badge-LATE')
      },
      badgeInProgress: {
        icon: 'spinner',
        color: 'info',
        backgroundColor: 'pale-blue',
        iconPack: 'fas',
        label: i18n.t('indicator-status-badge-IN_PROGRESS')
      },
      badgeTodo: {
        icon: 'eye',
        color: 'warning',
        backgroundColor: 'pale-yellow',
        iconPack: 'far',
        label: i18n.t('indicator-status-badge-TODO')
      },
      badgeDone: {
        icon: 'check',
        iconPack: 'fas',
        color: 'success',
        backgroundColor: 'pale-green',
        label: i18n.t('indicator-status-badge-DONE')
      },
      badgeDocumentsTodo: {
        icon: 'exclamation-triangle',
        iconPack: 'fas',
        color: 'grey',
        backgroundColor: 'grey-lightest',
        label: i18n.t('indicator-status-badge-DOCUMENTS_TODO')
      }
    }
  }
}
